import { onMounted, onUnmounted } from 'vue';

// 自定义的事件监听封装函数
export default function useEventListener() {
  const eventListener = (event, handler, element = window, capture = false) => {
    // 在组件挂载时添加事件监听
    onMounted(() => {
      element.addEventListener(event, handler, capture);
    });

    // 在组件卸载时移除事件监听
    onUnmounted(() => {
      element.removeEventListener(event, handler, capture);
    });
  };
  return {
    eventListener
  };
}
